import React from 'react';
import { Group, Skeleton, Text } from '@landr/maestro';
import { t } from '@lingui/macro';
import InfoPopover from 'components/InfoPopover/InfoPopover';
import { Included } from '../types';

const IncludedItem = ({
    item,
    isLoading,
    isMobile,
}: {
    item: Included;
    isLoading: boolean;
    isMobile: boolean;
}) => {
    const Icon = item.icon;

    if (isLoading) {
        return (
            <>
                <Skeleton width="98%" height="16px" mt={2} mb={9} />
            </>
        );
    }

    return (
        <Group gutter="xs">
            <Group.Item>
                <Icon size={isMobile ? 'sm' : 'md'} color="#32cbcb" />
            </Group.Item>
            <Group.Item>
                <Text size={isMobile ? 'md' : 'lg'}>{item.copy}</Text>
                {item?.tooltip && (
                    <InfoPopover aria-label={t`Details Tooltip`}>
                        {item.tooltip}
                    </InfoPopover>
                )}
            </Group.Item>
        </Group>
    );
};

export default IncludedItem;
